var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'my-dropdownItem',
    _vm.divided ? 'my-dropdownItem-divided' : '',
    _vm.disabled ? 'my-dropdownItem-disabled' : '' ],on:{"click":function($event){$event.stopPropagation();return _vm.handleItemClick.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }